/* unplugin-vue-components disabled */import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _slicedToArray from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import CTitle from '@/components/CTitle.vue';
import useDetailData from '../hooks/useDetailData';
import { useEmptyStringFormat } from '@/hooks/fn';
import CDateSelect from '@/components/CDateSelect.vue';
import CurrentSelect from './CurrentSelect.vue';
import { LineEchart } from '@/components/page-echarts';
import FixedInfo from './FixedInfo.vue';
import hyRequest from '@/service';
export default defineComponent({
  components: {
    CTitle: CTitle,
    CDateSelect: CDateSelect,
    CurrentSelect: CurrentSelect,
    LineEchart: LineEchart,
    FixedInfo: FixedInfo
  },
  name: 'DeviceDetail',
  props: {
    id: {
      type: String,
      required: true
    },
    deviceName: {
      type: String
    }
  },
  emits: ['update', 'to-detail'],
  setup: function setup(props) {
    var emptyStringFormat = useEmptyStringFormat();
    var params = computed(function () {
      return {
        deviceId: props.id
      };
    });
    var currentTrendParams = ref({
      startTime: dayjs().format('YYYY/MM/DD') + ' 00:00:00',
      endTime: dayjs().format('YYYY/MM/DD') + ' 23:59:59',
      variableId: '',
      variable_type: ''
    });
    var _useDetailData = useDetailData(params, currentTrendParams),
      _useDetailData2 = _slicedToArray(_useDetailData, 10),
      deviceInfo = _useDetailData2[0],
      newClassReal = _useDetailData2[1],
      deviceTemper = _useDetailData2[2],
      threeTemper = _useDetailData2[3],
      openCloseList = _useDetailData2[4],
      getDeviceInfoAsync = _useDetailData2[5],
      getNewClassRealAsync = _useDetailData2[6],
      getDeviceTemperAsync = _useDetailData2[7],
      getThreeTemperAsync = _useDetailData2[8],
      getOpenCloseMechineMoreAsync = _useDetailData2[9];
    var deviceTemperList = computed(function () {
      return ['5415', '5416', '5417', '5418'].includes(props.id) ? deviceTemper.value.flatMap(function (item) {
        return item.machiVariable.map(function (iten) {
          return _objectSpread({
            text: iten.key_name,
            value: iten.variableRealValue
          }, iten);
        });
      }) : deviceTemper.value.flatMap(function (item) {
        return item.machiVariable.map(function (iten) {
          return _objectSpread({
            //text: item.machinerName + '-' + iten.key_name,
            text: iten.key_name,
            value: iten.variableRealValue
          }, iten);
        });
      });
    });
    var tmpShow = ref(false);
    var maintainRecord = ref({
      device_name: '',
      maintain_time: '',
      next_time: '',
      person: '',
      remark: ''
    });
    var repairRecord = ref({
      check_name: '',
      check_persion: '',
      check_point_result: '',
      create_time: '',
      remark: null
    });
    var pointRecord = ref({
      check_name: '',
      check_persion: '',
      check_point_result: '',
      create_time: '',
      remark: {
        a: '',
        b: '',
        c: ''
      }
    });
    onMounted( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var data;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            hyRequest.post({
              url: '/deviceapp/deviceTempDetail',
              data: {
                deviceId: props.id
              }
            }).then(function (data) {
              tmpShow.value = data;
            });
            //近期保养
            hyRequest.post({
              url: '/repair/maintainRecordByDeviceIdCurrent',
              data: {
                device_id: props.id
              }
            }).then(function (data) {
              maintainRecord.value = data;
            });
            //近期维修
            hyRequest.post({
              url: '/repair/deviceRepairRecordByFactoryDeviceCurrent',
              data: {
                device_id: props.id
              }
            }).then(function (data) {
              console.log(data);
              repairRecord.value = data;
            });
            //近期点检
            hyRequest.post({
              url: '/repair/devicePointRecordByFactoryDeviceCurrent',
              data: {
                device_id: props.id
              }
            }).then(function (data) {
              data ? pointRecord.value = _objectSpread(_objectSpread({}, data), JSON.parse(data.remark)) : null;
              console.log(pointRecord);
            });
            getDeviceInfoAsync();
            getNewClassRealAsync();
            getOpenCloseMechineMoreAsync();
            _context.next = 9;
            return getDeviceTemperAsync();
          case 9:
            data = _context.sent;
            currentTrendParams.value.variableId = data.variableId;
            currentTrendParams.value.variable_type = data.variable_type;
            getThreeTemperAsync();
          case 13:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    watch(function () {
      return props.id;
    }, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var data;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            getDeviceInfoAsync();
            getNewClassRealAsync();
            getDeviceTemperAsync();
            getOpenCloseMechineMoreAsync();
            _context2.next = 6;
            return getDeviceTemperAsync();
          case 6:
            data = _context2.sent;
            currentTrendParams.value.variableId = data.variableId;
            currentTrendParams.value.variable_type = data.variable_type;
            getThreeTemperAsync();
          case 10:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    })));
    var formatDate = function formatDate(date) {
      return dayjs(date).format('YYYY/MM/DD');
    };
    var confirmDate = function confirmDate(value) {
      currentTrendParams.value.startTime = formatDate(value) + ' 00:00:00';
      currentTrendParams.value.endTime = formatDate(value) + ' 23:59:59';
      getThreeTemperAsync();
    };
    var confirmCurrent = function confirmCurrent(item) {
      currentTrendParams.value.variableId = item.variableId;
      currentTrendParams.value.variable_type = item.variable_type;
      getThreeTemperAsync();
    };
    var saleTrend = computed(function () {
      var list = threeTemper.value.map(function (item) {
        return item.value;
      });
      var xLabels = threeTemper.value.map(function (item) {
        return item.name;
      });
      return {
        lineData: list,
        xLabels: xLabels,
        legendData: [''],
        yName: '',
        grid: {
          top: '30',
          left: '5%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        }
      };
    });
    var router = useRouter();
    function changeMachineState(add) {
      router.push({
        path: '/MaintenanceList',
        query: {
          device_id: props.id,
          deviceName: props.deviceName,
          add: add
        }
      });
    }
    function changeRepairState(add) {
      router.push({
        path: '/RepairList',
        query: {
          device_id: props.id,
          deviceName: props.deviceName,
          add: add
        }
      });
    }
    function changePointRepairState(add) {
      router.push({
        path: '/PointRepairList',
        query: {
          device_id: props.id,
          deviceName: props.deviceName,
          add: add
        }
      });
    }
    return {
      deviceInfo: deviceInfo,
      emptyStringFormat: emptyStringFormat,
      newClassReal: newClassReal,
      deviceTemperList: deviceTemperList,
      confirmDate: confirmDate,
      confirmCurrent: confirmCurrent,
      saleTrend: saleTrend,
      openCloseList: openCloseList,
      tmpShow: tmpShow,
      changeMachineState: changeMachineState,
      changeRepairState: changeRepairState,
      changePointRepairState: changePointRepairState,
      maintainRecord: maintainRecord,
      repairRecord: repairRecord,
      pointRecord: pointRecord
    };
  }
});